export default __webpack_public_path__ + "7624e9e47f6218990ef871acec75c43a.png";